import React from 'react';
import { Button, Link } from 'carbon-components-react';
import { AddressType } from 'types';
import { getFullAddress } from 'utilities/helper.util';

const PopUp: React.FC<Props> = (props) => {
  const { onButtonClick, address, onLinkClick } = props;
  const handleButtonClick = () => {
    if (typeof onButtonClick === 'function') {
      onButtonClick();
    }
  };

  const handleLinkClick = () => {
    if (typeof onLinkClick === 'function') {
      onLinkClick();
    }
  };

  return (
    <div className="mis-parcel-popup-container">
      <div className="mis-parcel-popup-address">
        {address ? getFullAddress(address) : ''}
      </div>
      <div className="mis-parcel-popup-button">
        <Button onClick={handleButtonClick}>Use address as job site</Button>
      </div>
      <div className="mis-parcel-popup-footer">
        or <Link onClick={handleLinkClick}>draw your job site</Link>
      </div>
    </div>
  );
};
type Props = {
  onButtonClick?: Function;
  onLinkClick?: Function;
  address?: AddressType;
};

export default PopUp;
